'use client';

import Image from 'next/image';
import { PROJECT_NAME } from '@shared/constants';

interface DoctorHeroSectionProps {
  onJoinAsClinician: () => void;
}

/**
 * @group Doctors
 * @summary Hero section for doctors page
 */
export function DoctorHeroSection({ onJoinAsClinician }: DoctorHeroSectionProps) {
  return (
    <section className="relative bg-hero-bg py-20 lg:py-32">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <h1 className="text-4xl lg:text-5xl font-bold text-hero-text mb-6">
              Apply for a Fulltime Job as a Clinician
            </h1>
            <p className="text-xl text-[#B8B4B0] mb-8 leading-relaxed">
              Build your career with {PROJECT_NAME} in a team that values clinical autonomy,
              meaningful patient impact, and modern tools that reduce admin load. We're hiring
              clinicians who want stable, fulltime work while still practicing medicine with care
              and integrity.
            </p>
            <button
              onClick={onJoinAsClinician}
              className="px-8 py-4 bg-primary text-primary-foreground font-semibold rounded-lg hover:bg-primary/90 transition-colors shadow-lg hover:shadow-xl"
            >
              Apply for a Fulltime Job as a Clinician
            </button>
          </div>
          
          {/* Hero Image */}
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="relative aspect-[4/3] overflow-hidden rounded-2xl sm:col-span-2">
              <Image
                src="/img/clinician-role-hero.png"
                alt="Doctor practicing telemedicine"
                fill
                className="object-cover"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
